<script setup lang="ts">
import { ref, computed } from "vue";
import AContributionSave from "~/components/AContribution-save.vue";
import AContributionReplenished from "~/components/AContribution-replenished.vue";
import AOpenContribution from "~/components/AOpenContribution.vue";
import AMRA_BANK_LOGO from "@/assets/img/amra-bank.png";

const depositType = ref("Сохраняемый");
const depositAmount = ref(0);
const currency = ref("");
const termOfDeposit = ref(0);
const { t } = useI18n({useScope: "local"});

const activeComponent = ref("save");

function setActiveComponent(component: string) {
  activeComponent.value = component;
}


const route = useRoute();
const head = computed(() => {
  return {
    title: "Амра-Банк",
    meta: [
      {
        hid: "title",
        property: "title",
        content: `Амра-Банк`,
      },
      {
        hid: "description",
        name: "description",
        content:
          "Амра-банк это дебетовые карты, обмен валюты, обслуживание физических лиц, кредитование бизнеса, аренда сейфовых ячеек, дистанционное обслуживание юридических ли...",
      },
      {
        property: "og:title",
        name: "og:title",
        content: "Амра-Банк",
      },
      {
        property: "og:description",
        name: "og:description",
        content:
          "Амра-банк это дебетовые карты, обмен валюты, обслуживание физических лиц, кредитование бизнеса, аренда сейфовых ячеек, дистанционное обслуживание юридических ли...",
      },
      {
        property: "og:url",
        name: "og:url",
        content: `https://amra-bank.com/${route.fullPath}`,
      },
      {
        property: "url",
        name: "url",
        content: `https://amra-bank.com/${route.fullPath}`,
      },
      {
        property: "og:type",
        name: "og:type",
        content: "website",
      },
      {
        property: "og:site_name",
        name: "og:site_name",
        content: "Амра-Банк",
      },
      {
        property: "image",
        name: "image",
        content: `${AMRA_BANK_LOGO}`,
      },
      {
        property: "og:image",
        name: "og:image",
        content: `${AMRA_BANK_LOGO}`,
      },
    ],
  };
});

useHead(head);
</script>

<template>
  <NuxtLayout name="default">
    <ABalancer></ABalancer>
    <ADeposits></ADeposits>
    <ACalculator
      class="mt-8 lg:mt-14 container"
      v-model:deposit-type="depositType"
      v-model:deposit-amount="depositAmount"
      v-model:currency="currency"
      v-model:term-of-deposit="termOfDeposit"
    ></ACalculator>

    <div class="lg:hidden mt-6 block bg-[#F9F9F9]">
      <div class="container text-[#5E5E5E] font-firasans flex justify-between pt-3 px-4 md:px-0">
        <p
          class="text-lg cursor-pointer"
          :class="{
            'border-b-[4px] text-[#333333] pb-1 font-medium border-darkYellow':
              depositType === 'Сохраняемый',
          }"
          @click="depositType = 'Сохраняемый'"
        >
          {{ t('Сохраняемый') }}
        </p>
        <p
          class="text-lg pb-1 text-[#5E5E5E] cursor-pointer"
          :class="{
            'border-b-[4px]  font-medium border-darkYellow':
              depositType === 'Пополняемый',
          }"
          @click="depositType = 'Пополняемый'"
        >
          {{t('Пополняемый')}}
        </p>
      </div>

      <component
        :is="
          depositType === 'Сохраняемый'
            ? AContributionSave
            : AContributionReplenished
        "
      ></component>
    </div>

    <div class="hidden lg:block">
      <AContributionSave ></AContributionSave>
      <AContributionReplenished ></AContributionReplenished>
    </div>

    <AOpenContribution
      :deposit-type="depositType"
      :deposit-amount="depositAmount"
      :currency="currency"
      :term-of-deposit="termOfDeposit"
    ></AOpenContribution>
  </NuxtLayout>
</template>

<i18n lang="json">
 {
  "ru": {
    "Сохраняемый": "Сохраняемый",
    "Пополняемый": "Пополняемый"
  },
  "ab": {
    "Сохраняемый": "Ихьчоу ",
    "Пополняемый": "Иузҳарҭәаауа"
  },
  "en": {
    "Сохраняемый": "Fixed-term",
    "Пополняемый": "Replenishable"
  },
  "tr": {
    "Сохраняемый": "Sabit vadeli",
    "Пополняемый": "Eklenebilir"
  },
  "es": {
    "Сохраняемый": "A plazo fijo",
    "Пополняемый": "Reintegrable"
  },
  "ar": {
    "Сохраняемый": "ثابت الأجل",
    "Пополняемый": "قابل للتغذية"
  }
}
</i18n>